import cn from 'classnames';

import { formatNameLastNameFirst } from 'src/utils/formatName';
import { setJumpLinkAttributes } from 'src/utils/jumpLinks';

import Link from 'components/BaseHelpers/Link';
import Text from 'components/BaseHelpers/Text';

import { ComponentProps } from '../../../types/component-props';
import { CoreArticleAuthorsData } from '../../../types/components';

import styles from './CoreArticleAuthors.module.scss';

export type CoreArticleAuthorsProps = ComponentProps & CoreArticleAuthorsData;

const CoreArticleAuthors = (props: CoreArticleAuthorsProps): JSX.Element => {
  const { heading, people, jumpLinkLabel } = props.fields;

  if (people.length === 0) {
    return <></>;
  }

  return (
    <div className={cn(styles.main, 'container-10')} {...setJumpLinkAttributes(jumpLinkLabel)}>
      <Text tag="h2" className={cn(styles.heading, 'heading-h4')} field={heading} />
      <ul className={styles.list}>
        {people.map((person, index) => (
          <li key={index} className={styles.listItem}>
            <Link href={person.url} className={cn(styles.link, 'body-lg')}>
              {formatNameLastNameFirst(person)}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CoreArticleAuthors;
